import { fillInBlankUniqueValidation } from '../utils';
const survey = {
    startPage: 'example',
    name: 'Example Survey',
    urlName: 'example-survey',
    pages: [
        {
            pageName: 'example',
            nextPage: () => 'finish',
            questions: [
                {
                    type: 'multiple-choice',
                    label: 'How often do you eat breakfast?',
                    options: ['Everyday', 'Most days', 'Once a week', 'Once a Month', 'More rarely', 'Never'],
                    requireResponse: true,
                    id: 'example-mc'
                },
                {
                    type: 'fill-in-the-blank-list',
                    label: 'What are your favorite colors?',
                    id: 'which-other-languages',
                    requireResponse: true,
                    customValidation: fillInBlankUniqueValidation
                },
                {
                    type: 'text-block',
                    label: '# JSON-based Domain Specific Languages',
                    text: `
<br/>

wow this is phenonemanl content`,
                    id: 'intro',
                    requireResponse: false
                },
                {
                    id: 'which-dogs',
                    type: 'checkbox-question',
                    label: 'Which of the following are good dogs',
                    options: ['Scooby doo', 'lassy', 'shadow the dog', 'molly the border colly', 'clara the pug'],
                    requireResponse: true
                },
                {
                    type: 'matrix-question',
                    id: 'dog-quality',
                    label: 'How good are they',
                    rows: ['Scooby doo', 'lassy', 'shadow the dog', 'molly the border colly', 'clara the pug'],
                    columns: ['(1) Bad', '(2)', '(3) Okay', '(4)', '(5) Good! '],
                    requireResponse: true
                },
                {
                    id: 'dog-name',
                    type: 'text-input',
                    size: 'line',
                    label: `Whats a good dog name`,
                    requireResponse: true
                }
            ],
            couldBeFinal: true
        }
    ],
    endDate: new Date('2023-04-28T10:30:00.000-05:00')
};
export default survey;
